import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { notifyInstagramOpener } from '../utils/instagramOAuth';
import './WixProductEntry.css';
import './WixOnboarding.css';

// This landing page does not need a Wix grant or a portal login. The original
// onboarding window confirms success through its authenticated status request.
export default function InstagramOAuthReturn({result}) {
  const {t} = useTranslation();
  useEffect(() => {
    delete window.__UB_WIX_CALLBACK__;
    window.history.replaceState(window.history.state, '', window.location.pathname);
    let timer;
    try {
      if (notifyInstagramOpener(result)) timer = setTimeout(() => window.close(), 300);
    } catch { /* The original page also polls when the provider severs opener. */ }
    return () => clearTimeout(timer);
  }, [result]);
  return <main className="wxo-scope wxo-wrapper wix-product-entry">
    <img className="wxo-logo" src="/ultimo-bots-white.png" alt="Ultimo Bots" />
    <div className="wxo-stage"><section className="wxo-card wix-product-card">
      <h1 className="wxo-h2">{t('wix_instagram_return_title')}</h1>
      <p className="wxo-sub">{t(result === 'cancelled' ? 'wix_instagram_cancelled' : result === 'error' ? 'wix_instagram_connect_error' : 'wix_instagram_return_help')}</p>
      <p>{t('wix_instagram_return_tab')}</p>
      <button className="wxo-btn" onClick={() => window.close()}>{t('close')}</button>
    </section></div>
  </main>;
}
